import { render, staticRenderFns } from "./ApiBody.vue?vue&type=template&id=e8b6e38e&scoped=true&"
import script from "./ApiBody.vue?vue&type=script&lang=js&"
export * from "./ApiBody.vue?vue&type=script&lang=js&"
import style0 from "./ApiBody.vue?vue&type=style&index=0&id=e8b6e38e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b6e38e",
  null
  
)

export default component.exports